export const DASHBOARD_FONT =
  'Inter, "Segoe UI", Roboto, Arial, sans-serif';
export const DASHBOARD_NAVY = "#1F5F8F";
export const DASHBOARD_NAVY_HOVER = "#194E75";
export const DASHBOARD_TEXT = "#213449";
export const DASHBOARD_MUTED = "#5f7082";

export const dashboardOutlinedButtonSx = {
  fontFamily: DASHBOARD_FONT,
  textTransform: "none" as const,
  fontWeight: 700,
  color: DASHBOARD_NAVY,
  borderColor: "#b7c9d6",
  bgcolor: "#ffffff",
  boxShadow: "none",
  borderRadius: "8px",
  "&:hover": {
    borderColor: DASHBOARD_NAVY,
    bgcolor: "#f4f8fb",
    color: DASHBOARD_NAVY_HOVER,
    boxShadow: "none",
  },
};

export const dashboardContainedButtonSx = {
  fontFamily: DASHBOARD_FONT,
  textTransform: "none" as const,
  fontWeight: 700,
  color: "#ffffff",
  bgcolor: DASHBOARD_NAVY,
  boxShadow: "none",
  borderRadius: "8px",
  "&:hover": {
    bgcolor: DASHBOARD_NAVY_HOVER,
    boxShadow: "none",
  },
};
